import styled from '@emotion/styled';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { withConfig } from 'src/withConfig';

interface EventRowHeaderPropsType {
    variant: DefaultComponentVariantType | null;
}

export const EventRowHeader = withConfig(theme => styled('div', { label: 'EventRowHeader' })<EventRowHeaderPropsType>`
    border-right: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? 'none' : `1px solid  ${theme.star.eventRow.borderColor}`};
    display: flex;
    flex-flow: row nowrap;
    flex: 1 1 0%;
    min-width: 50px;
    transition: background-color .2s ease;
`);

export const EventRowMarkets = styled('div', { label: 'EventRowMarkets' })`
    min-width: 100%;
`;

interface EventRowSelectionsPropsType {
    variant: DefaultComponentVariantType | null;
}

export const EventRowSelections = withConfig(theme => styled('ul', { label: 'EventRowSelections' })<EventRowSelectionsPropsType>`
    display: flex;
    flex-flow: row nowrap;
    font-size: ${theme.star.fontSize.small};
    font-weight: ${theme.star.fontWeight.bold};
    justify-content: center;
    gap: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? theme.star.gap.small : '0'};
`);

export const EventRowSelectionsElement = styled('li', { label: 'EventRowSelectionsElement' })`
    display: flex;
    height: 100%;
`;

export const EventRowMetaTime = withConfig(theme => styled('span', { label: 'EventRowMetaTime' })`
    display: flex;
    align-content: center;
    font-size: ${theme.star.fontSize.xSmall};
    font-weight: ${theme.star.fontWeight.regular};
    line-height: 1.4;
`);

export const CompetitionWrapper = withConfig(theme => styled('div', { label: 'CompetitionWrapper' })`
    display: flex;
    flex-flow: column nowrap;
    gap: ${theme.star.gap.small};
`);
